import { render } from "./WordSearch.vue?vue&type=template&id=3375a123&scoped=true"
import script from "./WordSearch.vue?vue&type=script&lang=js"
export * from "./WordSearch.vue?vue&type=script&lang=js"

import "./WordSearch.vue?vue&type=style&index=0&id=3375a123&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3375a123"]])

export default __exports__